import { NotificationType } from "@markit/common.types";
import { Icon } from "@iconify/react";
import { useCallback } from "react";
import ConfirmDeleteModal from "../../../Containers/ConfirmPopups/ConfirmDeleteModal";
import { API } from "../../../../API";
import { Colors } from "../../../../utils/colors";
import { useDispatch } from "react-redux";
import { showNotificationBanner } from "../../../../utils/notificationUtils";

type DMAutomationConfirmDeleteModalProps = {
  id: string;
  dmAutomationId: string;
  type: "Automation" | "Trigger" | "Content";
  showDeleteModal: boolean;
  setShowDeleteModal: (showDeleteModal: boolean) => void;
  handleAfterDelete?: () => void;
};
export const DMAutomationConfirmDeleteModal = (
  props: DMAutomationConfirmDeleteModalProps
) => {
  const {
    id,
    dmAutomationId,
    type,
    showDeleteModal,
    setShowDeleteModal,
    handleAfterDelete,
  } = props;
  const dispatch = useDispatch();

  const deleteDMAutomation = useCallback(async () => {
    if (type === "Automation") {
      await API.dmAutomation.deleteDmAutomation({
        dmAutomationId: id,
      });
    } else if (type === "Trigger") {
      await API.dmAutomation.deleteDmAutomationTrigger({
        dmAutomationId: dmAutomationId,
        triggerId: id,
      });
    } else if (type === "Content") {
      await API.dmAutomation.deleteDmAutomationContent({
        dmAutomationId: dmAutomationId,
        contentId: id,
      });
    }
    setShowDeleteModal(false);
    showNotificationBanner(
      dispatch,
      `${type} Deleted!`,
      NotificationType.NEGATIVE,
      "ion:trash"
    );
    handleAfterDelete?.();
  }, [
    dispatch,
    dmAutomationId,
    handleAfterDelete,
    id,
    setShowDeleteModal,
    type,
  ]);

  return (
    <>
      <ConfirmDeleteModal
        heading={`Delete ${type}`}
        subtext={`Are you sure you want to delete this ${type.toLowerCase()}? This cannot be undone.`}
        deleteButtonText="Delete"
        icon={
          <Icon icon={"ion:trash"} height={35} style={{ color: Colors.RED3 }} />
        }
        hideModal={!showDeleteModal}
        setIsVisible={setShowDeleteModal}
        deleteOnPress={deleteDMAutomation}
      />
    </>
  );
};
